import { render, staticRenderFns } from "./InsabiCie10.vue?vue&type=template&id=ffeb0efa&"
import script from "./InsabiCie10.vue?vue&type=script&lang=js&"
export * from "./InsabiCie10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports